module.exports = __webpack_public_path__ + "static/img/top_bg_5.9db40d47.png";